import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// Dialog Titles and Labels
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.FranchiseeQuoteCreateProjectModal.';
  public static readonly newProject = `${Id.prefix}newProject`;
  public static readonly addToExistingProject = `${Id.prefix}addToExistingProject`;
  public static readonly statusProgressesMessage = `${Id.prefix}statusProgressesMessage`;
  public static readonly projectSiteAddress = `${Id.prefix}projectSiteAddress`;
  public static readonly projectTitle = `${Id.prefix}projectTitle`;
  public static readonly description = `${Id.prefix}description`;
  public static readonly projectBudget = `${Id.prefix}projectBudget`;
  public static readonly onlyProjectsWithMatchingClient = `${Id.prefix}onlyProjectsWithMatchingClient`;
  public static readonly cannotHaveEmptyProjectTitle = `${Id.prefix}cannotHaveEmptyProjectTitle`;
  public static readonly cannotHaveEmptyProjectAddress = `${Id.prefix}cannotHaveEmptyProjectAddress`;
  public static readonly pleaseSelectProjectToAddQuote = `${Id.prefix}pleaseSelectProjectToAddQuote`;
}

export class LangFranchiseeQuoteCreateProjectModal {
  private constructor() {}
  public static newProject(): string {
    return interpolate(Id.newProject);
  }
  public static addToExistingProject(): string {
    return interpolate(Id.addToExistingProject);
  }
  public static statusProgressesMessage(params: { draft: string; active: string }): string {
    return interpolate(Id.statusProgressesMessage, params);
  }
  public static projectSiteAddress(): string {
    return interpolate(Id.projectSiteAddress);
  }
  public static projectTitle(): string {
    return interpolate(Id.projectTitle);
  }
  public static description(): string {
    return interpolate(Id.description);
  }
  public static projectBudget(): string {
    return interpolate(Id.projectBudget);
  }
  public static onlyProjectsWithMatchingClient(): string {
    return interpolate(Id.onlyProjectsWithMatchingClient);
  }
  public static cannotHaveEmptyProjectTitle(): string {
    return interpolate(Id.cannotHaveEmptyProjectTitle);
  }
  public static cannotHaveEmptyProjectAddress(): string {
    return interpolate(Id.cannotHaveEmptyProjectAddress);
  }
  public static pleaseSelectProjectToAddQuote(): string {
    return interpolate(Id.pleaseSelectProjectToAddQuote);
  }
}

export class FranchiseeQuoteCreateProjectModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.newProject, "New {{glossary 'project'}}", 'Dialog title for creating a new project');
    register.add(
      Id.addToExistingProject,
      "Add to existing {{glossary 'project'}}",
      'Radio label for adding to existing project'
    );
    register.add(
      Id.statusProgressesMessage,
      "When a {{glossary 'quote'}}'s status progresses from {{draft}} to {{active}}, the system will generate a {{glossary 'project'}} to contain all relevant documentation. Alternatively, you may add the {{glossary 'quote'}} to an existing {{glossary 'project'}}.",
      'Message explaining project creation on quote status change'
    );
    register.add(
      Id.projectSiteAddress,
      "{{glossary 'project'}} (Site Installation) Address",
      'Label for project site address'
    );
    register.add(Id.projectTitle, "{{glossary 'project'}} Title", 'Label for project title');
    register.add(Id.description, 'Description', 'Label for description');
    register.add(Id.projectBudget, "{{glossary 'project'}} Budget", 'Label for project budget');
    register.add(
      Id.onlyProjectsWithMatchingClient,
      "Only {{glossary 'project:plural'}} with a matching {{glossary 'client'}} appear in the list below.",
      'Message for filtering projects by client'
    );
    register.add(
      Id.cannotHaveEmptyProjectTitle,
      "Cannot have an empty Title for the {{glossary 'project'}}",
      'Validation error for empty project title'
    );
    register.add(
      Id.cannotHaveEmptyProjectAddress,
      "Cannot have an empty Address for the {{glossary 'project'}}",
      'Validation error for empty project address'
    );
    register.add(
      Id.pleaseSelectProjectToAddQuote,
      "Please select a {{glossary 'project'}} to add this {{glossary 'quote'}} to.",
      'Validation error for missing project selection'
    );
  }
}
